<div class="modal-header">
  <h5 class="modal-title">Generation des charges mensuelles COMPTANT</h5>
  <button type="button" class="close" (click)="modal.close()">
    <span>&times;</span>
  </button>
</div>
<div class="modal-body">
  <!-- Configuration -->
  <div class="row mb-3">
    <div class="col-md-4">
      <label for="moisCible">Mois cible</label>
      <input type="month" class="form-control" id="moisCible" [(ngModel)]="moisCible">
    </div>
    <div class="col-md-4 d-flex align-items-end">
      <button class="btn btn-primary" (click)="generer()" [disabled]="loading">
        <i class="fas fa-cogs" *ngIf="!loading"></i>
        <i class="fas fa-spinner fa-spin" *ngIf="loading"></i>
        Generer les charges
      </button>
    </div>
  </div>

  <!-- Indicateurs -->
  <div class="row mb-3" *ngIf="rapport">
    <div class="col">
      <div class="card bg-light text-center p-3">
        <h4 class="mb-0 text-primary">{{ rapport.totalDossiers }}</h4>
        <small>Dossiers actifs</small>
      </div>
    </div>
    <div class="col">
      <div class="card bg-light text-center p-3">
        <h4 class="mb-0 text-success">{{ rapport.totalGeneres }}</h4>
        <small>Generees</small>
      </div>
    </div>
    <div class="col">
      <div class="card bg-light text-center p-3">
        <h4 class="mb-0 text-warning">{{ rapport.totalDoublons }}</h4>
        <small>Doublons</small>
      </div>
    </div>
    <div class="col">
      <div class="card bg-light text-center p-3">
        <h4 class="mb-0 text-danger">{{ rapport.totalErreurs }}</h4>
        <small>Erreurs</small>
      </div>
    </div>
    <div class="col">
      <div class="card bg-light text-center p-3">
        <h4 class="mb-0 text-info">{{ rapport.montantTotal | number }} F</h4>
        <small>Montant total</small>
      </div>
    </div>
  </div>

  <!-- Tableau de details -->
  <div *ngIf="rapport && rapport.details?.length > 0">
    <h6>Details de la generation ({{ rapport.moisCible }})</h6>
    <div class="table-responsive">
      <table class="table table-sm table-striped table-bordered">
        <thead class="thead-light">
          <tr>
            <th>N° Dossier</th>
            <th>Client</th>
            <th>Bien</th>
            <th class="text-right">Montant</th>
            <th class="text-center">Statut</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of rapport.details">
            <td>{{ item.dossier }}</td>
            <td>{{ item.client }}</td>
            <td>{{ item.bien }}</td>
            <td class="text-right">{{ item.montant | number }} F CFA</td>
            <td class="text-center">
              <span class="badge" [ngClass]="getBadgeClass(item.statut)">{{ item.statut }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Section erreurs -->
  <div *ngIf="rapport && rapport.erreurs?.length > 0" class="mt-3">
    <h6 class="text-danger">Erreurs</h6>
    <div class="alert alert-danger" *ngFor="let err of rapport.erreurs">
      <strong>{{ err.dossier }}</strong> ({{ err.client }}) : {{ err.message }}
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="modal.close()">
    Fermer <i class="feather icon-x-circle"></i>
  </button>
</div>
